document.documentElement.classList.remove('no-js');

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });

  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (content) content.hidden = open;
    });
  });
});
